// Terminal: no wizard navigation left, the only way on is the account's portal
import { useEffect } from 'react';

import {
  Button,
  Column,
  useWizardContext,
} from '../../../components';
import { useTownAssets } from '../../../stores';

const pageStateValidator = () => ({ valid: {}, errors: {}, pageValid: true });

function InviteAckSuccessPage() {
  const { assets } = useTownAssets();
  const { translate } = assets;
  const { setPageInfo, setMustConfirmClose, state } = useWizardContext();

  useEffect(
    () => {
      setPageInfo({ pageStateValidator });
      setMustConfirmClose(false);
    },
    [setPageInfo, setMustConfirmClose],
  );

  const loginUrl = `${state.invite?.prtnrInvtInfo?.target?.cstmrWww}/login`;

  return (
    <Column gap={6} className="flex-1 min-h-0 w-full overflow-y-auto p-2">
      <span className="text-center">
        {translate('partnerAccountCreated', 'statements')}
      </span>

      <span className="text-center">
        {translate('credentialsSentTo', 'statements', { email: state.email })}
      </span>

      <Button
        label={translate('goToLogin')}
        onClick={() => { window.location.assign(loginUrl); }}
        imgSrc="/images/svg/gui/next.svg"
        imgRight
        baseColor
      />
    </Column>
  );
}

export default InviteAckSuccessPage;
